import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
import { ref, watchEffect } from "vue";
// import { SetUp, BrushFilled } from "@element-plus/icons-vue"; //VideoCamera, Promotion, Memo, User, Place, Cpu, WindPower, SwitchFilled,
import { getRoot } from "@/root";
// import { ERouterName, Zh_CNName } from "@/types";

export default {
  __name: 'Menu',
  setup(__props) {
    const root = getRoot();
    const activeIndex = ref("devices");
    const handleSelect = key => root.$router.push("/" + key);
    watchEffect(() => {
      let href = root.$route.fullPath;
      activeIndex.value = href.replace("/", "");
    });
    const modules = [
      // {
      //   icon: Place,
      //   title: Zh_CNName.AIR_ROUTE,
      //   route: ERouterName.AIR_ROUTE,
      // },
      // {
      //   icon: VideoCamera,
      //   title: Zh_CNName.LIVESTREAM,
      //   route: ERouterName.LIVESTREAM,
      // },
      // {
      //   icon: Promotion,
      //   title: Zh_CNName.HISTORY,
      //   route: ERouterName.HISTORY,
      // },
      // {
      //   icon: Memo,
      //   title: Zh_CNName.STATISTICS,
      //   route: ERouterName.STATISTICS,
      // },
      // {
      //   icon: User,
      //   title: Zh_CNName.PERSONNEL,
      //   route: ERouterName.PERSONNEL,
      // },
      // {
      //   icon: SetUp,
      //   title: Zh_CNName.DEVICES,
      //   route: ERouterName.DEVICES,
      // },
      // {
      //   icon: BrushFilled,
      //   title: Zh_CNName.COLORS,
      //   route: ERouterName.COLORS,
      // },
      // {
      //   icon: Place,
      //   title: Zh_CNName.AIR_ROUTE,
      //   route: ERouterName.AIR_ROUTE,
      // },
      // {
      //   icon: Cpu,
      //   title: Zh_CNName.ELECTRONIC_FENCE,
      //   route: ERouterName.ELECTRONIC_FENCE,
      // },
      // {
      //   icon: WindPower,
      //   title: Zh_CNName.AIRPORT,
      //   route: ERouterName.AIRPORT,
      // },
      // {
      //   icon: SwitchFilled,
      //   title: Zh_CNName.MODEL,
      //   route: ERouterName.MODEL,
      // },
    ];

    // onMounted(() => {
    //   let href = root.$route.fullPath;
    //   console.log(755555,href);

    //   activeIndex.value = href.replace("/", "");
    // });

    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        class: _normalizeClass(["el-menu-demo", {
          'mobiles-menu': _ctx.$store.state.mobileTerminal
        }]),
        mode: "horizontal",
        ellipsis: false,
        onSelect: handleSelect,
        "background-color": _ctx.$store.state.BackgroundStatus.BackgroundColor,
        "text-color": _ctx.$store.state.BackgroundStatus.TextColor,
        "active-text-color": _ctx.$store.state.BackgroundStatus.ActiveTextColor
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(modules, item => {
          return _createVNode(_component_el_menu_item, {
            key: item.index,
            index: item.route,
            style: _normalizeStyle({
              '--hover-color': _ctx.$store.state.BackgroundStatus.HoverColor
            })
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["index", "style"]);
        }), 64))]),
        _: 1
      }, 8, ["default-active", "class", "background-color", "text-color", "active-text-color"])]);
    };
  }
};